import { Component } from 'react';
import PropTypes from 'prop-types';
import { Tabs } from '@platform/base';
import CompMeta from '../../meta/LowCodeComponents/NCTabPane';
/**
 * @class NCTabPane
 * @column 1
 * @compType 1
 * @canAppend true
 * @path LowCodeComponents.NCTabs.TabPane
 * @label 页签
 *
 */
class NCTabPane extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
        * @title 区域编码
        * @description 组件标识
        */
        moduleId: PropTypes.string.isRequired,
        /**
         * 
         * @title activeKey
         * @description activeKey
         */
        key: PropTypes.string,
        /**
         * @title tab
         * @description 选项卡头显示文字
         */
        tab: PropTypes.string,
    }
    static getCompMeta = () => {
        return CompMeta;
    }
    render() {
        return (
            <Tabs.TabPane {...this.props} className="lc-drop-area" />
        )
    }
}
export default NCTabPane;